export enum Flipper {
  Collections = 'collections',
  NavCollections = 'nav_collections',
}
